import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlpPaginationComponent } from './plp-pagination.component';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { CustomPaginationModule } from '../../../misc/pagination/pagination.module';

@NgModule({
  declarations: [PlpPaginationComponent],
  imports: [
    CommonModule,
    RouterModule,
    CustomPaginationModule,

    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        PlpPagination: {
          component: PlpPaginationComponent,
        },
      },
    }),
  ],
  exports: [PlpPaginationComponent],
})
export class PlpPaginationModule {}
